// extracted by mini-css-extract-plugin
export default {"Login":"Login_Login__B-0At","content":"Login_content__UemON","title":"Login_title__3JYIy"};